export default __webpack_public_path__ + "static/Policy Contract_EzyMedical (MV)-47f097904ded7b4399b7c64823aee0d9.pdf";